import { com, kotlin } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import Patch from './Patch'
import { ConflictError } from './postEntities'
import requireAuthContext from '../../authorization/requireAuthContext'
import serializeToJsonString = com.eidu.sharedlib.entity.util.serializeToJsonString
import PatchEntityRequest = com.eidu.sharedlib.entity.api.entities.PatchEntityRequest
import KtMap = kotlin.collections.KtMap
import EntityId = com.eidu.sharedlib.entity.EntityId

type PatchEntityParameters = {
  id: EntityId
  patch: Patch
}

const patchEntity = async ({ id, patch }: PatchEntityParameters) => {
  const authContext = await requireAuthContext()
  const response = await fetch(
    `${entityApiUrl}/organizations/${authContext.organizationId}/entities/${id.toString()}`,
    {
      headers: {
        Authorization: `Bearer ${authContext.accessToken}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: serializeToJsonString(
        new PatchEntityRequest(
          patch.valuesToUpdateByFieldId ? KtMap.fromJsMap(patch.valuesToUpdateByFieldId) : KtMap.fromJsMap(new Map()),
          patch.linksToUpdate ? KtMap.fromJsMap(patch.linksToUpdate) : KtMap.fromJsMap(new Map()),
          patch.externalValuesToUpdate ? KtMap.fromJsMap(patch.externalValuesToUpdate) : KtMap.fromJsMap(new Map())
        )
      ),
      method: 'PATCH',
    }
  )
  if (response.status === 409) {
    throw new ConflictError('Entity update conflict')
  } else if (response.status !== 200) {
    throw Error(`Unexpected response code ${response.status} from patchEntity endpoint`)
  }
}

export default patchEntity
